import { TimeTrackingMask } from '../../../../../components/time-tracking-mask/mask';
import { useMaskConfig } from '../../hooks/mask-context';
import { MaskControllerProps } from '../../types';

export const TimeTrackingOverlayController = (props: MaskControllerProps) => {
  const mask = useMaskConfig(props);

  return (
    <TimeTrackingMask
      open
      id={mask.id as number}
      close={() => props.onAfterSave(null)}
      mode={mask.isCreateMode ? 'create' : 'edit'}
    />
  );
};
